export const SIDEBAR_TOGGLE = '@sidebar/SIDEBAR_TOGGLE';